<div class="litmus-down-screen-container">
  <div class="litmus-down-screen-text text-center mx-auto px-3 px-md-0">
    <i class="nemo-font nemo-info info-icon" aria-hidden="true"></i>
    <p class="litmus-down-text">
    <p class="litmus-down-text">
      {{ 'SHARED.GENERIC_LTI.LITMUS_DOWN_TEXT' | translate }}
    </p>
    <p class="litmus-down-description">
      {{ 'SHARED.GENERIC_LTI.LITMUS_DOWN_SCREEN_MSG1' | translate }}
    </p>
    <button type="button" class="btn back-to-dashboard-btn" data-dismiss="modal" qid="litmus-unavail-screen-1"
      [attr.aria-label]="'SHARED.GENERIC_LTI.LITMUS_DOWN_SCREEN_BUTTON' | translate" (click)="navigateToDashboard()">
      {{ 'SHARED.GENERIC_LTI.LITMUS_DOWN_SCREEN_BUTTON' | translate }}
    </button>
  </div>
  <div>
    <img class="svg-icon w-100" alt="" src='{{imageBasePath}}assets/img/litmus-down.svg'/>
  </div>
</div>